import React, { useState } from "react";
import axios from "axios";
import Linkedin from "../assests/linkedin.png";
import Instagram from "../assests/insta.png";
import Whatsapp from "../assests/whatsapp.png";

import '../css/all.css';

 
function Connect() {
  const [serverState, setServerState] = useState({
    submitting: false,
    status: null
  });
  const handleServerResponse = (ok, msg, form) => {
    setServerState({
      submitting: false,
      status: { ok, msg }
    });
    if (ok) {
      form.reset();
    }
  };
  const handleOnSubmit = e => {
    e.preventDefault();
    const form = e.target;
    setServerState({ submitting: true });
    axios({
      method: "post",
      url: "https://formspree.io/maypvera",
      data: new FormData(form)
    })
      .then(r => {
        handleServerResponse(true, "Thanks!", form);
      })
      .catch(r => {
        handleServerResponse(false, r.response.data.error, form);
      });
  };
  return (
    <div className="container pt-5 connectForm">
      
        <div className="row align-items-center ">
       <div className="cardConnectCard container contact m-3"> 
       <h3 className="mb-4  " >Connect</h3>
      <form onSubmit={handleOnSubmit}>
         
        <input id="email" type="email" name="email" placeholder="Email" required />
        <br></br>
         
        <textarea id="message" name="message" placeholder="Message"></textarea>
        <br></br>
        <button type="submit" className="submitBtn" disabled={serverState.submitting}>
          Submit
        </button>
        
      </form>
    </div>
    </div>
    <div className="row foot container">
    <div className="col  align-items-center name">
                            =
                            <h2 className="subject">Social Media</h2>
                            <div className="container mt-3 tcenter">
                                <div className="row tcenter mb-2">
                               <a href="www.linkedin.com/in/yeahsk"> <img alt="pic" src={Linkedin}  className="mx-auto d-block mb-2"></img></a>
                                 
                                </div>
                                <div className="row tcenter mb-2">
                                <a href="https://www.instagram.com/satyam_khandekar_/"><img alt="pic" src={Instagram}  className="mx-auto d-block mb-2"></img></a>
                              
                                </div>
                                <div className="row tcenter">
                                <a href="https://wa.me/917743991542/?text=Hello%Satyam"><img alt="pic" src={Whatsapp}  className="mx-auto d-block mb-2"></img></a>
                                <br></br>
                                </div>
                                
                                </div>
                                </div>
    </div>
    {serverState.status && (
          <p className={!serverState.status.ok ? "errorMsg" : ""}>
            <div className="alert alert-primary" role="alert">
        This is a primary alert—check it out!
      </div>
          </p>
        )}
    </div>
  );
};

export default Connect;